import Hero from '@/components/feature/Hero';

export default function Home() {
  return <Hero />;
}